import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
// import { isNumber } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import CmsContext from 'context/CmsContext';
import moment from 'moment';
import Select from 'react-select';
import Profession from 'modules/OHP/healthPermit/components/Profession';
import { customStyle } from 'helper';
import Citizenship from './Citizenship';

import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createInputNumber,
  createSelect,
  updateCdl,
  showTransaction,
  formData,
  updateList,
  setFormData,
  transactId,
  validId,
  updating,
  moduleId,
  getCitizenshipList,

  getRegionList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,

  regionList,
  provinceList,
  municipalityList,
  barangayList,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      module_id: moduleId,
    };
    updateCdl(moduleId, args, () => {
      setModal({ isOpen: false });
      showTransaction(transactId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        valid_id_to_present: validId,
      };
      setFormData(_.pick(args, _.keys(c.CEDULA_EDIT_FORM)));
    }
  };

  useEffect(() => {
    getRegionList();
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(updateList, 'region_code'),
    });
  }, [])

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(updateList, 'province_code', 'place_of_birth_province_code'),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(
        updateList,
        'municipality_code',
        'place_of_birth_municipality_code'
      ),
    });
  }, []);

  useEffect(() => {
    if(!_.get(formData, 'is_employed_individual')){
      setFormData({
        ...formData,
        additional_residence_tax_1: 0,
        additional_residence_tax_2: 0,
        additional_residence_tax_3: 0,
        additional_residence_tax_cedula_1: 50,
        additional_residence_tax_cedula_2: 0,
        additional_residence_tax_cedula_3: 0,
      })
    } else {
      setFormData({
        ...formData,
        additional_residence_tax_1: 150000,
      })
    }
  }, [formData.is_employed_individual])

  useEffect(() => {
    if(_.get(formData, 'is_employed_individual')){
      setFormData({
        ...formData,
        additional_residence_tax_cedula_1: (_.get(formData, 'additional_residence_tax_1') / 1000),
        additional_residence_tax_cedula_2: (_.get(formData, 'additional_residence_tax_2') / 1000),
        additional_residence_tax_cedula_3: (_.get(formData, 'additional_residence_tax_3') / 1000),
      })
    }
  }, [formData.additional_residence_tax_1, formData.additional_residence_tax_2, formData.additional_residence_tax_3, ])

  useEffect(() => {
    onSetFormData();
    getCitizenshipList();
  }, {});

  const commonValidation = {
    tax_payer_account_number: 'required|tax_payer_account_number',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation)
  }, [])

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  /* eslint-disable eqeqeq */
  const getSelectedOptions = (list, value) => {
    return createDropdown(list).find(x => x.value == value) || {};
  };

  const handleRegionSelect = e => {
    setFormData({
      ...formData,
      region_code: e.value,
    });
    getProvinceList({ region_code: e.value });
  };

  const handleProvinceSelect = e => {
    setFormData({
      ...formData,
      province_code: e.value,
    });
    getMunicipalityList({ province_code: e.value });
  };

  const handleMunicipalitySelect = e => {
    setFormData({
      ...formData,
      municipality_code: e.value,
    });
    getBarangayList({ municipality_code: e.value });
  };

  const handleBarangaySelect = e => {
    setFormData({
      ...formData,
      barangay_code: e.value,
    });
  };

  // const handleBirthplaceProvinceSelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_province_code: e.value,
  //   });
  //   getMunicipalityList({ province_code: e.value });
  // };

  // const handleBirthplaceMunicipalitySelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_municipality_code: e.value,
  //   });
  //   getBarangayList({ municipality_code: e.value });
  // };

  // const handleBirthplaceBarangaySelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_barangay_code: e.value,
  //   });
  // };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleOnChangeEmployed = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
      profession_code: e.target.checked ? _.get(updateList, 'profession_code') : null,
    });
  }

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="col-12 form-group">
            {' '}
            Document Owner&apos;s Information{' '}
          </label>

          <div className="col-6 form-group">
            {createInput({ key: 'last_name', label: 'Last Name:' })}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'first_name', label: 'First Name:' })}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'middle_name', label: 'Middle Name:' })}
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-4 form-group">
            {createSelect(
              {
                key: 'gender',
                label: 'Gender:',
              },
              c.GENDER
            )}
          </div>
          <div className="col-4 form-group">
            <label className="form-label">Birth Date:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('birth_date')}
              value={
                `${moment(_.get(formData, 'birth_date')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 form-group">
            {createSelect(
              {
                key: 'civil_status',
                label: 'Civil Status:',
              },
              c.CIVIL_STATUS
            )}
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'height', label: 'Height:' })}
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'weight', label: 'Weight:' })}
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                key: 'valid_id_to_present',
                label: 'Valid ID:',
              },
              c.VALID_IDS
            )}
          </div>
          <div className="col-12 pt-1">
            <div className="">
              <label className="form-label">Select Region:
                <span className="text-danger"> <i>Required</i> </span>
              </label>
              <div>
                <Select
                  value={getSelectedOptions(
                    regionList,
                    formData.region_code,
                  )}
                  styles={customStyle}
                  placeholder="Select Region"
                  options={createDropdown(regionList)}
                  onChange={e => {
                    handleRegionSelect(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-6 pt-1">
            <div className="">
              <label className="form-label">Select Province:
                <span className="text-danger"> <i>Required</i> </span>
              </label>
              <div>
                <Select
                  value={getSelectedOptions(
                    provinceList,
                    formData.province_code
                  )}
                  styles={customStyle}
                  placeholder="Select Province"
                  options={createDropdown(provinceList)}
                  onChange={e => {
                    handleProvinceSelect(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-6 pt-1">
            <label className="form-label">Select Municipality:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(municipalityList)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={getSelectedOptions(
                  municipalityList,
                  formData.municipality_code
                )}
                onChange={e => {
                  handleMunicipalitySelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-6 pt-1">
            <label className="form-label">Select Barangay:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(barangayList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(barangayList, formData.barangay_code)}
                onChange={e => {
                  handleBarangaySelect(e)
                }}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'street', label: 'Street:' })}
          </div>
          {/* <div className="col-4 pt-1">
            <div className="">
              <label className="form-label">Select Province:
                <span className="text-danger"> <i>Required</i> </span>
              </label>
              <div>
                <Select
                  value={getSelectedOptions(
                    provinceList,
                    formData.place_of_birth_province_code
                  )}
                  styles={customStyle}
                  placeholder="Select Province"
                  options={createDropdown(provinceList)}
                  onChange={e => {
                    handleBirthplaceProvinceSelect(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">Select Municipality:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(municipalityList)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={getSelectedOptions(
                  municipalityList,
                  formData.muniplace_of_birth_cipality_code
                )}
                onChange={e => {
                  handleBirthplaceMunicipalitySelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">Select Barangay:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(barangayList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(barangayList, formData.place_of_birth_barangay_code)}
                onChange={e => {
                  handleBirthplaceBarangaySelect(e)
                }}
              />
            </div>
          </div> */}

          <div className="col-4 form-group">
            <label>Country of Citizenship</label>
            <Citizenship
              name="citizenship_code"
              onChange={handleOnChange}
              value={_.get(formData, 'citizenship_code') || ''}
            />
          </div>
          <div className="col-4 form-group">
            <label>Residence Tax Due:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('residence_tax_due')}
              value={
                `${moment(_.get(formData, 'residence_tax_due')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 form-group">
            <label htmlFor="last_name" className="form-label">Tax Payer Account No.: {validateForm.renderMessage('tax_payer_account_number')}</label>
            <InputMask
              className="form-control"
              mask="999-999-999-99999"
              alwaysShowMask
              type="text"
              name="tax_payer_account_number"
              onChange={handleOnChange}
              value={_.get(formData, 'tax_payer_account_number')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Employed: &nbsp;
            </label>
            <input
              name="is_employed_individual"
              type="checkbox"
              checked={_.get(formData, 'is_employed_individual')}
              onChange={handleOnChangeEmployed}
            />
          </div>
          {_.get(formData, 'is_employed_individual') ? (
            <>
              <div className="col-12 font-weight-bold">
                Profession
              </div>
              <div className="col-6 form-group">
                <Profession
                  name="profession_code"
                  onChange={handleOnChange}
                  value={_.get(formData, 'profession_code') || ''}
                />
              </div>
              <div className="col-12 font-weight-bold">
                Income from Real Property (₱1.00 for every ₱1.000.00)
              </div>
              <div className="col-3 form-group">
                {createInputNumber({ key: 'additional_residence_tax_1', label: 'Taxable Amount:' })}
              </div>
              <div className="col-3 form-group">
                {createInputNumber({ key: 'additional_residence_tax_cedula_1', label: 'Cedula Amount:', isReadOnly: true })}
              </div>
              {!_.get(CMS_COMPONENTS, 'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX') && (
                <>
                  <div className="col-12 font-weight-bold">
                    Gross Receipts or Earnings derived from Business during the preceding year (₱1.00 for every ₱1,000.00)
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_2', label: 'Taxable Amount:' })}
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_cedula_2', label: 'Cedula Amount:', isReadOnly: true })}
                  </div>
                  <div className="col-12 font-weight-bold">
                    Salaries or Gross Receipts or earnings derived from exercise of profession or pursuit of any occupation (₱1.00 for every ₱1,000.00)
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_3', label: 'Taxable Amount:' })}
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_cedula_3', label: 'Cedula Amount:', isReadOnly: true })}
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div className="col-12 font-weight-bold">
                Income from Real Property (₱1.00 for every ₱1.000.00)
              </div>
              <div className="col-3 form-group">
                {createInputNumber({ key: 'additional_residence_tax_1', label: 'Taxable Amount:', isReadOnly: true })}
              </div>
              <div className="col-3 form-group">
                {createInputNumber({ key: 'additional_residence_tax_cedula_1', label: 'Cedula Amount:', isReadOnly: true })}
              </div>
              {!_.get(CMS_COMPONENTS, 'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX') && (
                <>
                  <div className="col-12 font-weight-bold">
                    Gross Receipts or Earnings derived from Business during the preceding year (₱1.00 for every ₱1,000.00)
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_2', label: 'Taxable Amount:', isReadOnly: true })}
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_cedula_2', label: 'Cedula Amount:', isReadOnly: true })}
                  </div>
                  <div className="col-12 font-weight-bold">
                    Salaries or Gross Receipts or earnings derived from exercise of profession or pursuit of any occupation (₱1.00 for every ₱1,000.00)
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_3', label: 'Taxable Amount:', isReadOnly: true })}
                  </div>
                  <div className="col-3 form-group">
                    {createInputNumber({ key: 'additional_residence_tax_cedula_3', label: 'Cedula Amount:', isReadOnly: true })}
                  </div>
                </>
              )}
            </>
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateCdl: PropTypes.instanceOf(Function).isRequired,
  moduleId: PropTypes.string.isRequired,
  transactId: PropTypes.string.isRequired,
  validId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  getCitizenshipList: PropTypes.instanceOf(Function).isRequired,

  getRegionList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,

  regionList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TRANSACTION) > -1,
  regionList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
